import history from '~/services/history'

export const handleErrorToken = () => {
  const [, campaignId] = window.location.pathname.split('/')
  history.push(`/${campaignId}`)
}
